import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { HiChevronDown, HiChevronRight, HiChevronUp } from 'react-icons/hi2';

import { PageItem } from '@/types/page';

type Props = {
  item: PageItem;
};

const SideBarItem = ({ item }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleOpen = () => {
    if (item.hasChildren) {
      return setIsOpen(!isOpen);
    } else {
      navigate(item.path);
    }
  };

  return (
    <nav
      key={item.title}
      className="flex min-w-[240px] flex-col gap-1 p-1 text-base font-normal"
    >
      <div className="relative block w-full">
        <div
          role="button"
          className="flex w-full items-center p-0 text-start leading-tight outline-none transition-all hover:bg-gray-100 hover:bg-opacity-80 hover:text-gray-500 focus:bg-opacity-80 active:bg-blue-50 active:bg-opacity-80 active:text-blue-900"
        >
          <button
            type="button"
            onClick={handleOpen}
            className="flex w-full select-none items-center justify-between border-b-0 p-3 text-left text-xl font-semibold leading-snug antialiased transition-colors hover:bg-gray-100 hover:text-gray-500"
          >
            <div className="mr-4 grid place-items-center">{item.icon}</div>
            <p className="mr-auto block text-base font-normal leading-relaxed antialiased">
              {item.title}
            </p>
            {item.hasChildren && (
              <span className="ml-4">{isOpen ? <HiChevronUp /> : <HiChevronDown />}</span>
            )}
          </button>
        </div>
        {isOpen && (
          <div className="overflow-hidden">
            <div className="block w-full py-1 text-sm font-light leading-normal text-gray-700 antialiased">
              <nav className="flex min-w-[240px] flex-col gap-1 p-0 text-base font-normal text-gray-700">
                {item.children?.map((child) => (
                  <div
                    key={child.title}
                    role="button"
                    onClick={() => navigate(child.path)}
                    className="flex w-full items-center rounded-lg p-3 text-start leading-tight outline-none transition-all hover:bg-gray-100 hover:bg-opacity-80 focus:bg-opacity-80 active:bg-opacity-80"
                  >
                    <div className="mr-4 grid place-items-center">
                      <HiChevronRight />
                    </div>
                    {child.title}
                  </div>
                ))}
              </nav>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default SideBarItem;
